<div class="user-roles">
  @if (!loaded) {
    <div class="text-muted"><i class="fa fa-spinner fa-spin"></i> Chargement...</div>
  }
  @if (loaded && noAccount) {
    <div class="text-muted">Aucun compte utilisateur associé à cet email.</div>
  }

  @if (loaded && !noAccount) {
    @if (errorMessage) {
      <div class="alert alert-danger py-2">{{ errorMessage }}</div>
    }
    <div class="user-roles__list">
      @if (userRoles.length === 0) {
        <span class="text-muted">Aucun rôle attribué</span>
      }
      @for (role of userRoles; track role) {
        <span class="badge text-bg-info user-roles__badge">
          {{ label(role) }}
          @if (canManage(role)) {
            <button type="button" class="user-roles__remove"
              (click)="removeRole(role)" [disabled]="loadingRole !== null" title="Retirer ce rôle">
              @if (loadingRole === role) {
                <span class="spinner-border spinner-border-sm"></span>
              }
              @if (loadingRole !== role) {
                <span>&times;</span>
              }
            </button>
          }
        </span>
      }
    </div>
    @if (availableRoles.length > 0) {
      <div class="user-roles__add">
        <span class="user-roles__add-label">Ajouter :</span>
        @for (role of availableRoles; track role) {
          <button type="button" class="btn btn-sm btn-outline-success"
            (click)="addRole(role)" [disabled]="loadingRole !== null">
            @if (loadingRole === role) {
              <span class="spinner-border spinner-border-sm"></span>
            }
            @if (loadingRole !== role) {
              <span>+ {{ label(role) }}</span>
            }
          </button>
        }
      </div>
    }
    @if (canEdit) {
      <small class="d-block text-muted mt-3">
        <i class="fa fa-info-circle"></i> Pris en compte à la prochaine connexion de l'utilisateur.
      </small>
    }
  }
</div>
